import { useCallback, useEffect } from 'react';

import { batch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAppDispatch, useAppSelector } from 'redux/store/store.types';

import { setEventTrigger, setHasUnreadMessages } from '../store/app-chat.slice';
import { EChatEventType } from '../types/app-chat.type';

export default function ChatEventsTrigger() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { eventTrigger, onChatPage } = useAppSelector((state) => state.appChat);
  const triggerHandler = useCallback(() => {
    if (eventTrigger) {
      if (eventTrigger.type === EChatEventType.NEW_MESSAGE && !onChatPage) {
        toast.success(
          <p
            className="cursor-pointer"
            onClick={() => history.push(`/communication?channel=${eventTrigger.message?.chat_id}`)}
          >
            New Message
          </p>,
          {
            toastId: 'new-message',
          },
        );
        batch(() => {
          dispatch(setEventTrigger(null));
          dispatch(setHasUnreadMessages(true));
        });
      }
    }
  }, [eventTrigger, onChatPage, history]);

  useEffect(() => {
    triggerHandler();
  }, [eventTrigger]);
  return null;
}
